import type { IconData } from '@stacksjs/iconify-core'

export const databaseF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 10a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3m5 6a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-3 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2M5 6a1 1 0 1 0 0-2a1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default databaseF
